import { Box, Heading, Image, Paragraph, TextButton } from '@zillow/constellation-10';
import zillowAndPlaidSvg from '@assets/zillow-plaid.svg';

export const VerificationInProgress = ({ onDeletePaymentMethodClick }) => {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'token(spacing.md)' }}>
      <Image alt="zillow-plaid" css={{ width: '2500' }} src={zillowAndPlaidSvg as unknown as string} />
      <Heading level={2} textStyle="heading-xs">
        Verification in progress
      </Heading>
      <Paragraph>
        Your account will be automatically verified by Plaid in approximately one day. No action is needed on your part.
      </Paragraph>
      <TextButton
        css={{ alignSelf: 'flex-start', color: 'text.feedback.critical.hero' }}
        onClick={onDeletePaymentMethodClick}
      >
        Remove this payment method
      </TextButton>
    </Box>
  );
};
